import React, { createContext, useState } from "react";

export const LanguageContext = createContext();

const getInitialLanguage = () => {
  try {
    if (typeof navigator === "undefined") return "no";
    const browserLang = (navigator.language || "").toLowerCase();
    const langCode = browserLang.split("-")[0];
    return langCode === "nb" || langCode === "nn" || langCode === "no"
      ? "no"
      : "en";
  } catch {
    return "no";
  }
};

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(getInitialLanguage);

  return (
    <LanguageContext.Provider value={{ language, setLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
};
